module.exports = __webpack_public_path__ + "media/images/gallery/constellations/scutum/sct_gc-c18cee7339021ba7bfd90eb734b1fcca.gif";